<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="user-survey">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm12 md11 lg11 elevation-6>
                <div class="sub-window">
                    <v-toolbar v-if="$vuetify.breakpoint.xsOnly===true" dark color="teal darken-3" prominent>
                        <v-toolbar-title>
                            <v-card class="mx-auto transparent" width="100%" elevation="0">
                                <v-card-text class="white--text text-sm-left title font-weight-bold pt-0 pb-0">
                                    Nueva encuesta - {{ surveyUserName }}
                                </v-card-text>
                                <v-card-text class="white--text text-sm-left subtitle-1 pt-0 pb-0">
                                    {{ surveyUserGender }}, {{ surveyUserAge }} años
                                    <br>
                                    {{ surveyUserOrgLevel }}, {{ this.userSurveyData.email }} 
                                </v-card-text>
                            </v-card>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn text @click="onExit" v-on="on">
                                    <v-icon color="white">mdi-close</v-icon>
                                </v-btn>
                            </template>
                            Cancelar la encuesta
                        </v-tooltip>
                    </v-toolbar>
                    <v-toolbar v-else dark color="teal darken-3">
                        <v-toolbar-title>
                            Nueva encuesta - {{ surveyUserName }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>
                            <v-card class="mx-auto transparent" width="100%" elevation="0">
                                <v-card-text class="white--text text-sm-left subtitle-1 pt-0 pb-0">
                                    {{ surveyUserGender }}, {{ surveyUserAge }} años
                                    <br>
                                    {{ surveyUserOrgLevel }}, {{ this.userSurveyData.email }} 
                                </v-card-text>
                            </v-card>
                        </v-toolbar-title>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn text @click="onExit" v-on="on">
                                    <v-icon color="white">mdi-close</v-icon>
                                </v-btn>
                            </template>
                            Cancelar la encuesta
                        </v-tooltip>
                    </v-toolbar>

                    <!-- Container para contenido principal: -->
                    <v-container grid-list-md fluid>
                        <!-- Introducción de cada caso: ********************************************* -->
                        <v-layout v-if="bShowCaseIntro" row justify-center>
                                <case-introduction :caseNumber="caseNumber" :caseIntro="caseIntro"></case-introduction>
                        </v-layout>

                        <!-- Situación de cada caso: ********************************************* -->
                        <v-layout v-if="bShowSituations" row>
                                <case-situation :caseNumber="caseNumber" :situationNumber="situationNumber" :situationType="situationType" :situation="situationTxt" :situationAnswers="situationAnswers"></case-situation>
                        </v-layout>

                        <!-- Autoevaluación de una situación: ********************************************* -->
                        <v-layout v-if="bShowAutoEvaluation" row>
                                <situation-autoevaluation :caseNumber="caseNumber" :situationNumber="situationNumber" :autoevaluation="autoevaluation"></situation-autoevaluation>
                        </v-layout>
                        
                        
                        <v-layout align-center justify-end row fill-height>
                            <v-flex xs12 sm8 class="text-xs-center text-end">
                                <v-btn
                                    color="pink accent-3"
                                    class="text-none"
                                    text
                                    @click="onPrev"
                                    :disabled="!bShowPrevButton"
                                >
                                    <v-icon color="pink accent-3"
                                        >mdi-chevron-left</v-icon
                                    >Regresar
                                </v-btn>
                                <v-btn
                                    v-if="!enableSendSurvey"
                                    color="cyan darken-3"
                                    class="text-none"
                                    text
                                    @click="onNext(situationType)"
                                >
                                    Continuar
                                    <v-icon color="cyan darken-3"
                                        >mdi-chevron-right</v-icon
                                    >
                                </v-btn>
                                <v-btn
                                    v-else
                                    color="cyan darken-3"
                                    class="text-none"
                                    text
                                    @click="onSend(situationType)"
                                >
                                    Finalizar Encuesta &nbsp;
                                    <v-icon color="cyan darken-3"
                                        >mdi-check</v-icon
                                    >
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <!-- Modal para confirmar cancelación: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bCancelDlg" persistent :width="modalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Nueva encuesta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-exit-run</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex x12 class="text-xs-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    x12
                                                    class="text-xs-center"
                                                >¿Desea cancelar la nueva encuesta?</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onConfirmCancel"
                                        >Cancelar la encuesta</v-btn>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onContinueSurvey"
                                        >Continuar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar canclación *************************** -->

                        <!-- Modal para confirmar finalización: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bSendingDlg" persistent :width="modalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Finalizar encuesta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-email-send</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex x12 class="text-xs-center">
                                                    <v-icon large color="orange darken-2">mdi-email-send</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    x12
                                                    class="text-xs-center"
                                                >¿Desea finalizar la encuesta?</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSend"
                                        >Cancelar</v-btn>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSend"
                                        >Finalizar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar canclación *************************** -->
                        <!-- Modal para pedir que se seleccione una respuesta de autoevaluación: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bMissingAutoEvalDlg"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Autoevaluación</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-alert-circle-outline</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >Por favor seleccione una respuesta de autoevaluación.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bMissingAutoEvalDlg = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se seleccione una respuesta de autoevaluación *********************************** -->

                        <!-- Modal para pedir que se seleccione una respuesta priorizada: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bMissingPrioritizedAnswerDlg"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Respuesta Priorizada</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-alert-circle-outline</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >Por favor seleccione el orden de prioridad para todas las respuestas.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bMissingPrioritizedAnswerDlg = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se seleccione una respuesta de autoevaluación *********************************** -->

                        <!-- Modal indicar que hubo algún error al procesar los resultados: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="surveyResultsError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Error</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-alert-circle-outline</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >Hubo un error al procesar los resultados de la encuesta.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="surveyResultsError = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal indicar que hubo algún error al procesar los resultados *********************************** -->
                        
                    </v-container>
                    <!-- Termina container para contenido principal -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash'; //Para ordenamiento de arreglos.
import goTo from 'vuetify/es5/services/goto'; //Para scroll
import CaseIntroduction from '../components/CaseIntroduction.vue';
import CaseSituation from '../components/CaseSituation.vue';
import SituationAutoevaluation from '../components/SituationAutoevaluation.vue';

export default {
    name: 'Languages',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            bInvalidData: false,
            errorMessage: '',
            bHideIntro: false, //Indica si ya no se debe volver a desplegar la Introducción, en caso de haber.
            bCancelDlg: false,
            bShowPrevButton: false,
            enableSendSurvey: false,
            bSendingDlg: false,
            bMissingAutoEvalDlg: false,
            bMissingPrioritizedAnswerDlg: false,

            caseIndex: 0,
            situationIndex: 0,
            bShowCaseIntro: true,
            bShowSituations: false,
            bShowAutoEvaluation: false,
        };
    },

    components: {
        CaseIntroduction,
        CaseSituation,
        SituationAutoevaluation
    },

    created() {
        
        console.log('En UserSurvey, userSurveyData = ', this.userSurveyData);
        this.caseIndex = 0;
        //this.caseNumber = this.userSurveyData.casos[this.caseIndex].numCaso;;
        //this.caseIntro = this.userSurveyData.casos[this.caseIndex].intro;
        this.bShowCaseIntro = true;
    },
    
    methods: {
        onExit() {
            //this.$store.dispatch('logout');
            this.bCancelDlg = true;
        },
        onConfirmCancel(){
            this.bCancelDlg = false;
            this.$router.push('/').catch(err => {});
        },
        onContinueSurvey(){
            this.bCancelDlg = false;
        },

        onSend(situationType) {
            //Si estamos en una autoevaluación, se checa que se haya seleccionado una respuesta:
            if (this.bShowAutoEvaluation)
            {
                //console.log("tipoAutoevaluacion = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.tipoAutoevaluacion);
                //console.log("respuesta = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuesta);
                //console.log("respuestaReal = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuestaReal);
                //console.log("infoComplementaria = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.infoComplementaria);

                if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.tipoAutoevaluacion === 0)
                {
                    if ((this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuesta === 0) ||
                        (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuestaReal === 0))
                    {
                        this.bMissingAutoEvalDlg = true;
                    }
                }
                else
                if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.infoComplementaria === 0)
                {
                    
                    this.bMissingAutoEvalDlg = true;
                }
            }
            else
            //Si estamos en una situación priorizada, se checa que se hayan seleccionado todas las respuestas:
            if (this.bShowSituations && situationType === "2")
            {
                var i;
                for (i = 0; i < this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas.length; i ++)
                {
                    console.log("Respuesta = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas[i].contestada);

                    if ((this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas[i].contestada === '0') || 
                        (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas[i].contestada === 0))
                    {
                        this.bMissingPrioritizedAnswerDlg = true;
                        break;
                    }
                }
            }

            if ((!this.bMissingAutoEvalDlg) && (!this.bMissingPrioritizedAnswerDlg))
            {
                this.bSendingDlg = true;
            }
        },

        onCancelSend()
        {
            this.bSendingDlg = false;
        },

        onConfirmSend()
        {
            this.$store.dispatch('sendSurvey', this.userSurveyData);
            //console.log("Survey to send: ", this.userSurveyData);
            this.bSendingDlg = false;
        },

        onNext(situationType)
        {
            // console.log("$vuetify.breakpoint = ", this.$vuetify.breakpoint);
            // console.log("$vuetify.breakpoint.smAndDown = ", this.$vuetify.breakpoint.smAndDown);
            // console.log("$vuetify.breakpoint.smAndDown===true", this.$vuetify.breakpoint.smAndDown===true)
            

            this.bShowPrevButton = true; //Siempre se que presiona el botón "Siguiente" se puede regresar.

            if (this.bShowCaseIntro) //Estamos el la introducción del caso actual...
            {
                this.bShowCaseIntro = false;

                //Pasa a la primera situación del caso actual:
                //this.situationNumber = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].numSituacion;
                //this.situationTxt = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].situacion;
                //this.situationAnswers = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas;

                //Si la situación no tiene autoevaluación, checa si estamos en el último caso. Si es así, checa si hay más situaciones.
                //Si no hay más situaciones, se habilita el botón de "Finalizar Encuesta":
                this.enableSendSurvey = false;
                if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.texto === null) //La situación actual no tiene autoevaluación...
                {
                    if (this.caseIndex + 1 === this.userSurveyData.casos.length) //Estamos en el último caso...
                    {
                        if (this.situationIndex + 1 === this.userSurveyData.casos[this.caseIndex].situaciones.length) //Estamos en la última situación...
                        {
                            console.log("Estamos en la última situación del último caso, y además esta situación no tiene autoevaluación.");
                            this.enableSendSurvey = true;
                        }
                    }
                }

                this.bShowSituations = true;
            }
            else
            if (this.bShowSituations) //Estamos en una situación...
            {
                //Si estamos en una situación de priorizar respuestas, checa que se hayan seleccionado todas las respuestas:
                if (situationType === "2")
                {
                    var i;
                    for (i = 0; i < this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas.length; i ++)
                    {
                        if ((this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas[i].contestada === '0') ||
                            (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas[i].contestada === 0))
                        {
                            this.bMissingPrioritizedAnswerDlg = true;
                            break;
                        }
                    }
                }

                if (!this.bMissingPrioritizedAnswerDlg)
                {
                    this.bShowSituations = false;

                    //Si la situación actual tiene autoevaluación, la mostramos ahora:
                    if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.texto !== null)
                    {
                        //console.log("La situación actual tiene autoevaluación...");

                        this.bShowAutoEvaluation = true;

                        //Si estamos en el último caso y en la última situación, se habilita el botón de "Finalizar Encuesta":
                        if (this.caseIndex + 1 === this.userSurveyData.casos.length)
                        {
                            console.log("Estamos en una autoevaluación, y estamos en el último caso....");
                            if (this.situationIndex + 1 === this.userSurveyData.casos[this.caseIndex].situaciones.length) //Estamos en la última situación...
                            {
                                console.log("Estamos en la última situación...");
                                this.enableSendSurvey = true;
                            }
                        }
                    }
                    else //La situación actual no tiene autoevaluación...
                    {
                        //Si hay más situaciones, se pasa a la siguiente situación:
                        if (this.situationIndex + 1 < this.userSurveyData.casos[this.caseIndex].situaciones.length)
                        {
                            console.log("Pasamos a la siguiente situación...");

                            this.situationIndex ++;

                            //this.situationNumber = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].numSituacion;
                            //this.situationTxt = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].situacion;
                            //this.situationAnswers = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas;

                            //Si la siguiente situación es la última del último caso y no tiene autoevaluación, se habilita el botón de "Finalizar Encuesta":
                            if (this.caseIndex + 1 === this.userSurveyData.casos.length) //Estamos en el último caso...
                            {
                                console.log("Estamos en el último caso...");
                                if (this.situationIndex  + 1 === this.userSurveyData.casos[this.caseIndex].situaciones.length) //Estamos en la última situación...
                                {
                                    console.log("Estamos en la última situación...");
                                    if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.texto === null) //No hay autoevaluación...
                                    {
                                        console.log("La última situación no tiene autoevaluación...");
                                        this.enableSendSurvey = true;
                                    }
                                }
                            }

                            this.bShowSituations = true;
                        }
                        else //No hay más situaciones en el caso actual...
                        {
                            //Checa si hay más casos:
                            if (this.caseIndex + 1 < this.userSurveyData.casos.length)
                            {
                                this.caseIndex ++; //Se pasa al siguiente caso.
                                this.situationIndex = 0;
                                // this.caseIntro = this.userSurveyData.casos[this.caseIndex].intro;
                                // this.caseNumber = this.userSurveyData.casos[this.caseIndex].numCaso;
                                this.bShowCaseIntro = true;
                            }
                            else //No hay más casos...
                            {
                                console.log("Error inesperado.....No hay razón para llegar a este else, ya que cuando no hay más situaciones ni más casos el botón 'Continuar' está deshabilitado.");
                            }
                        }
                    }
                }
            }
            else
            if (this.bShowAutoEvaluation)//Estamos en una autoevaluación...
            {
                //Checa que se haya seleccionado una respuesta:

                //console.log("tipoAutoevaluacion = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.tipoAutoevaluacion);
                //console.log("respuesta = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuesta);
                //console.log("respuestaReal = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuestaReal);
                //console.log("infoComplementaria = ", this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.infoComplementaria);

                if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.tipoAutoevaluacion === 0)
                {
                    if ((this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuesta === 0) ||
                        (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuestaReal === 0))
                    {
                        this.bMissingAutoEvalDlg = true;
                    }
                }
                else
                if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.infoComplementaria === 0)
                {
                    this.bMissingAutoEvalDlg = true;
                }

                if (!this.bMissingAutoEvalDlg)
                {
                    this.bShowAutoEvaluation = false;

                    //Checa si hay más situaciones en el caso actual...
                    if (this.situationIndex + 1 < this.userSurveyData.casos[this.caseIndex].situaciones.length) //Hay más situaciones en el caso actual...
                    {
                        console.log("Estamos en la autoevaluación de una situación que no es la última. Pasamos a la siguiente situación...");
                        this.situationIndex ++;

                        console.log("SituationIndex = ", this.situationIndex);
                        console.log("caseIndex = ", this.caseIndex);

                        //Si la siguiente situación es la última del último caso y no tiene autoevaluación, se habilita el botón de "Finalizar Encuesta":
                        if (this.caseIndex + 1 === this.userSurveyData.casos.length) //Estamos en el último caso...
                        {
                            console.log("Estamos en el último caso...");
                            if (this.situationIndex  + 1 === this.userSurveyData.casos[this.caseIndex].situaciones.length) //Estamos en la última situación...
                            {
                                console.log("Estamos en la última situación...");
                                if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.texto === null) //No hay autoevaluación...
                                {
                                    console.log("La última situación no tiene autoevaluación...");
                                    this.enableSendSurvey = true;
                                }
                            }
                        }

                        this.bShowSituations = true;
                    }
                    else
                    //Checa si hay más casos...
                    if (this.caseIndex  + 1 < this.userSurveyData.casos.length)
                    {
                        console.log("Hay más casos. Pasamos al siguiente...");
                        this.caseIndex ++;
                        this.situationIndex = 0;
                        //this.caseIntro = this.userSurveyData.casos[this.caseIndex].intro;
                        //this.caseNumber = this.userSurveyData.casos[this.caseIndex].numCaso;
                        this.bShowCaseIntro = true;
                    }
                    else
                    {
                        
                        //console.log("Estamos en la autoevaluación de la última situación. Se habilita 'Finalizar Encuesta'...");
                        //this.enableSendSurvey = true;
                        console.log("Error inesperado. No hay razón para llegar a este else.")
                    }
                }
            }
            goTo(0); //Scroll hasta arriba.
        },

        onPrev() {
            this.enableSendSurvey = false;
            if (this.bShowSituations)
            {
                //Si estamos en la primera situación de un caso, se pasa a la introducción del mismo caso,
                //y si estamos en el primer caso se deshabilita el botón "Regresar":
                if (this.situationIndex === 0)
                {
                    this.bShowSituations = false;
                    this.bShowCaseIntro = true;
                    if (this.caseIndex === 0)
                    {
                        this.bShowPrevButton = false;
                    }
                }
                else //Si no estamos en la primera situación, se disminuye el índice de la situación actual:
                {
                    console.log("situationIndex = ", this.situationIndex);
                    console.log("Pasamos a la situación anterior...");
                    console.log("surveyData = ", this.userSurveyData);
                    this.situationIndex --;

                    //console.log("situationIndex = ", this.situationIndex);
                    //this.situationNumber = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].numSituacion;
                    //this.situationTxt = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].situacion;
                    //this.situationAnswers = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas;

                    //Si esta situación tiene autoevaluación, se muestra:
                    if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.texto !== null)
                    {
                        console.log("La situación anterior tiene autoevaluación...");
                        this.bShowSituations = false;
                        this.bShowAutoEvaluation = true;
                    }
                }
            }
            else
            //Si estamos en la introducción de un caso, se regresa a la última situación del caso anterior.
            if (this.bShowCaseIntro)
            {
                this.bShowCaseIntro = false;
                this.caseIndex --;
                this.situationIndex = this.userSurveyData.casos[this.caseIndex].situaciones.length - 1;

                //Si la situación anterior tiene autoevaluación, se muestra:
                if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.texto !== null)
                {
                    this.bShowAutoEvaluation = true;
                }
                else //Si la situación anterior no tiene autoevaluación, se muestra la situación:
                {
                    this.bShowSituations = true;
                }
            }
            else
            if (this.bShowAutoEvaluation)//Si estamos en una autoevaluación, se pasa a la situación de la misma:
            {
                //*****  Se comentó el siguiente bloque porque tal vez sea mejor que si se va el usuario hacia atrás no se valide que se haya seleccionado respuesta: ********

                //Primero se checa que sí se haya seleccionado una respuesta:

                // if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.tipoAutoevaluacion === 0)
                // {
                //     if ((this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuesta === 0) ||
                //         (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.respuestaReal === 0))
                //     {
                //         this.bMissingAutoEvalDlg = true;
                //     }
                // }
                // else
                // if (this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion.infoComplementaria === 0)
                // {
                //     this.bMissingAutoEvalDlg = true;
                // }

                // if (!this.bMissingAutoEvalDlg)
                // {
                    this.bShowAutoEvaluation = false;
                    this.bShowSituations = true;
                //}
            }
            goTo(0); //Scroll hasta arriba.
        }
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'userName',
            'userSurveyData',
            'ageRanges',
            'genders',
            'organizationalLevels'
        ]),

        surveyUserName() {
            var strUserName = this.userSurveyData.apaterno;
            if (this.userSurveyData.amaterno !== "")
            {
                strUserName += " " + this.userSurveyData.amaterno;
            }
            strUserName += " " + this.userSurveyData.nombre;
            return strUserName;
        },

        surveyUserAge() {
            var strAge = "";
            var i;
            for (i = 0; i < this.ageRanges.length; i ++)
            {
                if (this.ageRanges[i].rangoedadid === this.userSurveyData.edadid)
                {
                    strAge = this.ageRanges[i].rangoEdad;
                    break;
                }
            }
            return strAge;
        },

        surveyUserGender() {
            var strGender = "";
            var i;
            for (i = 0; i < this.genders.length; i ++)
            {
                if (this.genders[i].generoid === this.userSurveyData.generoid)
                {
                    strGender = this.genders[i].genero;
                    break;
                }
            }
            return strGender;
        },

        surveyUserOrgLevel() {
            var strLevel = "";
            var i;
            for (i = 0; i < this.organizationalLevels.length; i ++)
            {
                if (this.organizationalLevels[i].nivelorganizacionalid === this.userSurveyData.nivelorganizacionalid)
                {
                    strLevel = this.organizationalLevels[i].nivelOrganizacional;
                    break;
                }
            }
            return strLevel;
        },

        caseNumber()
        {
            var num = this.userSurveyData.casos[this.caseIndex].numCaso;
            return num;
        },

        caseIntro()
        {
            var intro = this.userSurveyData.casos[this.caseIndex].intro;
            return intro;
        },

        situationNumber()
        {
            var num = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].numSituacion;
            return num;
        },

        situationType()
        {
            var sitType = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].tipoSituacion;
            return sitType;
        },

        situationTxt()
        {
            var txt = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].situacion;
            return txt;
        },
        
        situationAnswers()
        {
            var answers = [];
            answers = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].respuestas;
            return answers;
        },

        autoevaluation()
        {
            var autoeval = this.userSurveyData.casos[this.caseIndex].situaciones[this.situationIndex].autoevaluacion;
            return autoeval;
        },

       surveyResultsError: {
            get() {
                return this.$store.getters.surveyResultsError;
            },
            set(surveyResultsError) {
                this.$store.dispatch('updateSurveyResultsError', surveyResultsError);
            },
        },

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '25%';
            }
            return width;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '35%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '50';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '60';
            } else if (this.$vuetify.breakpoint.md) {
                height = '70';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.85);
}
.user-survey {
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

.enter-line {
    white-space: pre-wrap;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>